export default __webpack_public_path__ + "static/media/foot-right-front.ba07e00a.png";